import { Injectable } from '@angular/core';
import { PERFILESUSUARIO } from '../constants/app-values';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AppStorage {
  constructor(private router: Router) {}

  datosSesion: {
    usuario: string;
    perfil: any;
  };

  conSesion: boolean;
  loadingSesion: boolean;
  loadingGeneral = false;

  cognitoCoordinador = false;

  token: string;

  perfilesUsuario = PERFILESUSUARIO;
  inputName = 'pwd_input';

  // Detalle Empresa
  empresa;

  getPerfil() {
    if (!this.datosSesion) {
      return '';
    }

    if (
      this.datosSesion.perfil === this.perfilesUsuario.COORDINADOR_ADMINISTRADOR
    ) {
      return '(Admin)';
    } else if (
      this.datosSesion.perfil === this.perfilesUsuario.COORDINADOR_EDITOR
    ) {
      return '(Coordinador Editor)';
    } else if (
      this.datosSesion.perfil === this.perfilesUsuario.EMPRESA_EDITOR
    ) {
      return '(Empresa Editor)';
    } else {
      return '';
    }
  }

  goHome() {
    if (this.datosSesion) {
      if (
        this.datosSesion.perfil ===
          this.perfilesUsuario.COORDINADOR_ADMINISTRADOR ||
        this.datosSesion.perfil === this.perfilesUsuario.COORDINADOR_EDITOR
      ) {
        this.router.navigate(['/coordinador']);
      } else if (
        this.datosSesion.perfil === this.perfilesUsuario.EMPRESA_EDITOR
      ) {
        this.router.navigate(['/coordinados']);
      }
    }
  }
}
